import $ from 'jquery';
import { TabUserIdentifier } from "./common/TabUserIdentifier";


export class Site {
	private $body: JQuery;

	constructor() {
		this.$body = $('body');
		new TabUserIdentifier();
	}

}